import { useDataSubmit, useDataValue } from 'Simple/Data.js'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'

export function useOnClick(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)

  let submit = useDataSubmit({
    context: 'task',
    viewPath: props.viewPath,
  })

  let title = useDataValue({
    context: 'task_title',
    path: 'title',
    viewPath: props.viewPath,
  })

  let task_id = useDataValue({
    context: 'task',
    path: 'id',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({
      type: 'set_task_title',
      title,
      task_id,
    })
    setFlowTo(normalizePath(props.viewPath, '../Content'))
  }
}
